import Banner from "@buildpy/ui/banner";
import { FilterBar, SearchField } from "@/components/filter-bar";
import { Button } from "@buildpy/ui/button";
import { listHref } from "@buildpy/core/modules/list/search";

interface Props {
  action: string;
  q: string;
  "aria-label": string;
  placeholder: string;
  // 검색해도 남겨 둘 칩 조건(상태 등) — 숨은 input 으로 같이 가고, 쪽은 1로 돌아간다.
  keep?: Record<string, string | null | undefined>;
  // 고객 이름이 상한을 넘게 맞아 일부 고객의 줄만 찾았다(`ListPage.nameMatchCapped`).
  nameMatchCapped?: boolean;
}

export const NAME_MATCH_CAPPED_TEXT = "이름이 겹치는 고객이 많아 일부 고객의 결과만 보입니다 — 공사명으로 찾거나 고객 목록에서 고객을 먼저 찾아 주세요.";

// 목록 위 검색 한 줄 — 고객 목록과 같은 GET 폼(FilterBar)이라 검색어가 URL 에 살고, 초기화는 검색어만 지운다.
const ListSearch = ({ action, q, "aria-label": ariaLabel, placeholder, keep = {}, nameMatchCapped = false }: Props) => {
  const hidden = Object.entries(keep).filter((entry): entry is [string, string] => Boolean(entry[1]));
  return (
    <>
      <FilterBar action={action} filtered={Boolean(q)} resetHref={listHref(action, keep)}>
        {hidden.map(([name, value]) => (
          <input key={name} name={name} type="hidden" value={value} />
        ))}
        {/* 초기화·뒤로가기로 URL 검색어만 바뀌어도 칸이 옛 글자를 들고 있지 않게 다시 그린다. */}
        <SearchField key={q} aria-label={ariaLabel} defaultValue={q} name="q" placeholder={placeholder} />
        <Button size="sm" type="submit" variant="outline">
          검색
        </Button>
      </FilterBar>
      {nameMatchCapped && <Banner tone="warning">{NAME_MATCH_CAPPED_TEXT}</Banner>}
    </>
  );
};

export default ListSearch;
